import React from 'react';
import './SmartNavigation.css';

// Import the new image
import navImage from '../../assets/images/smart-navigation.png';

const SmartNavigation = () => {
  return (
    <section className="smart-nav-section">
      <div className="smart-nav-container">
        {/* Left Column: Image */}
        <div className="smart-nav-image-col">
          <img src={navImage} alt="Smart navigation and personalization interface" />
        </div>

        {/* Right Column: Text Content */}
        <div className="smart-nav-text-col">
          <h2>Smart navigation & user personalization</h2>
          <p>
            Easily browse tenders by commodity and buy/sell type. Download tender documents in one click and access contact details for faster communication. Whether bidding or planning, CRISHI makes the entire process smoother and faster.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SmartNavigation;